const defaultHexColors: {[key in string]: string} = {
    red: '#ff0000',
    blue: '#0000ff', 
    yellow: '#ffff00', 
    navy: '#000080', 
    orange: '#ffa500', 
    green: '#008000', 
    aqua: '#00ffff', 
    black: '#000000', 
    white: '#ffffff',
    brown: "#a52a2a",
    grey: '#808080'
}

export const defaultColorToHex = (color: string) => {
    if(!color || !(color in defaultHexColors)) return defaultHexColors.grey
    return defaultHexColors[color]
}

export const proccessLabelColor = (color: string) => {
    const correctColor = color && color.includes('#') ? color : defaultColorToHex(color)
    const cc = hexToRGB(correctColor, 0.24)
    return cc
}

export function hexToRGB(hex: string, alpha: number) {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
  
    if (alpha) {
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    } else {
      return `rgb(${r}, ${g}, ${b})`;
    }
}
